import { Dispatch } from "redux";

export const SET_SUBCATEGORYINFO = "SET_SUBCATEGORYINFO";
export const SET_DATASUBCATEGORYINFO = "SET_DATASUBCATEGORYINFO";

export const setSubcategoryInfo = (subCategoryInfo: any) => (
  dispatch: Dispatch<any>
) => {
  dispatch({
    type: SET_SUBCATEGORYINFO,
    payload: subCategoryInfo
  });
};

export const setDataSubcategoryInfo = (data: any) => (
  dispatch: Dispatch<any>
) => {
  dispatch({
    type: SET_DATASUBCATEGORYINFO,
    payload: data
  });
};
